import { createAsyncThunk } from '@reduxjs/toolkit'
import { ColumnFiltersState } from '@tanstack/react-table'
import { Axios } from 'api/axios'
import axios from 'axios'
const API_URL = process.env.REACT_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

export interface Warehouse {
  id?: number
  packageName: string
  districtCode: string
  districtName: string
  state: string
  status: boolean
  createBy?: string
  updatedBy?: string
  createDate?: string
  updateDate?: string
}
export interface PaginatedResponse<T> {
  count: number
  total_pages: number
  next: string | null
  previous: string | null
  results: T[]
}
interface ColumnFilterResponse {
  data: string[];
}
interface ColumnDropdownPayload {
  column: string;
  data: string[];
}


// Main fetchWarehouse thunk
export const fetchWarehouse = createAsyncThunk(
  'warehouse/Warehouse',
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters
  }: {
    page: number
    pageSize: number
    search?: string
    sort?: string
    order?: 'asc' | 'desc' | ''
    filters?: ColumnFiltersState
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize
      }

      if (search) params.search = search?.trim() || '';
      if (sort) params.ordering = order === 'desc' ? `-${sort}` : sort;

        if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if (
            (id === 'updated_at' || id === 'created_at') &&
            typeof value === 'object'
          ) {
            const { from_date, to_date } = value as {
              from_date?: string
              to_date?: string
            }
            if (id === 'updated_at') {
              if (from_date) params['updated_at_from'] = from_date
              if (to_date) params['updated_at_to'] = to_date
            }
            if (id === 'created_at') {
              if (from_date) params['created_at_from'] = from_date
              if (to_date) params['created_at_to'] = to_date
            }
            
          } else {
            params[id] = value
          }
        })
      }

      const response: any = await Axios.get(`/warehouse/list/`, { params });
      // console.log("response-------------1", response?.data)

      const responseData = response.data;

      return {
        data: responseData.results || [],
        rowCount: typeof responseData.total_records === 'number' ? responseData.total_records : 0
      };
    } catch (error: any) {
      console.error(
        'fetchWarehouse error:',
        error.response?.data || error.message
      );
      throw new Error('Failed to fetch warehouses');
    }
  }
);

export const fetchWarehouseById = createAsyncThunk(
  'warehouse/fetchWarehouseById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/organisation/${id}/`)
      console.log('resp to update Id : ', response)
      return response
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || 'Failed to fetch organisations by ID'
      )
    }
  }
)

export const updateWarehouse = createAsyncThunk(
  'warehouse/updateWarehouse',
  async (packageData: any) => {
    console.log('pkgData:', packageData)
    const response: any = await Axios.put(
      `${API_URL}api/warehouse/${packageData.id}/update/`,
      packageData
    )
    //console.log('updateOrganisation response:', response)
    return response
  }
)
export const updateStatusInWarehouse = createAsyncThunk(
  'warehouse/updateStatusInWarehouse',
  async ({ id, warehouse_status }: { id: string; warehouse_status: boolean }) => {
    console.log("iiiiii");
    try {
      const response = await Axios.put(
        `/warehouse/warehouse_status/${id}/`,
        {
          warehouse_id: id,
          warehouse_status,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Status update failed:", error.response?.data || error.message);
      throw error;
    }
  }
);


export const updateStatusInWarehouseFiFo = createAsyncThunk(
  'warehouse/updateStatusInWarehouseFiFo',
  async ({ id, enable_FIFO }: { id: string; enable_FIFO: boolean }) => {
    console.log("iiiiii");
    try {
      const response = await Axios.put(
        `/warehouse/enable_FIFO_ststus/${id}/`,
        {
          warehouse_id: id,
          enable_FIFO: enable_FIFO,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Status update failed:", error.response?.data || error.message);
      throw error;
    }
  }
);





export const addWarehouse = createAsyncThunk(
  'warehouse/addWarehouse',
  async (packageData: any) => {
    const response = await Axios.post(`${API_URL}/warehouse/Warehouse_create/`, packageData)
    //console.log('addWarehose response:', response)
    //console.log('addWaehosue response:', response.data)
    return response.data
  }
)

export const deleteWarehouse = createAsyncThunk(
  'warehouse/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`, { headers })
      return id
    } catch (err: any) {
      console.error('Delete error:', err)
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

export const fetchWarehouseColumnDropdown = createAsyncThunk<
  ColumnDropdownPayload,
  string
>(
  'warehouse/fetchWarehouseColumnDropdown',
  async (column, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_URL}/warehouse/warehouse/column_filter/`,
        {
          params: { column_filter: column },
          headers,
        }
      );

      const rawData = response.data?.data || [];

      const uniqueValuesSet = new Set(
        rawData
          .map((item: any) => item?.[column])
          .filter((value: string | null) => value !== null && value !== '')
      );

      const data = Array.from(uniqueValuesSet) as string[];

      return { column, data };
    } catch (err: any) {
      console.error('Error fetching dropdown:', err);
      return rejectWithValue(err.response?.data || 'Failed to fetch dropdown');
    }
  }
);


// Exports warehouse CSV file
export const exportWarehouseCSV = createAsyncThunk(
  'warehosue/exportWarehouseCSV',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      const response = await Axios.get(
        '/warehouse/list/?export=excel',
        { headers, responseType: 'blob' }
      );
      return {
        blob: response.data,
        filename:
          response.headers['content-disposition']
            ?.split('filename=')[1]
            ?.replace(/"/g, '') || 'warehouse.csv'
      };
    } catch (err: any) {
      console.error('Export CSV error:', err);
      return rejectWithValue(err.message || 'Failed to export CSV');
    }
  }
);

export const WarehosuesxportsCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  params.append("export", "csv");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        id,
        value,
      }: {
        id: string;
        value: any;
      }) => {
        if (id && value !== undefined && value !== null) {
          if (typeof value === "object" && value !== null) {
            // Type guard for date filter
            const maybeDateFilter = value as {
              from_date?: string;
              to_date?: string;
            };

            if (
              (maybeDateFilter.from_date || maybeDateFilter.to_date) &&
              (id === "created_at" || id === "updated_at")
            ) {
              const filterId = id === "created_at" ? "created" : "updated";

              if (maybeDateFilter.from_date) {
                params.append("from_date", maybeDateFilter.from_date);
              }

              if (maybeDateFilter.to_date) {
                params.append("to_date", maybeDateFilter.to_date);
              }

              params.append("filter_by", filterId);
              return;
            }

            // Add all other key-values
            Object.entries(value).forEach(([key, val]) => {
              if (val !== undefined && val !== null && val !== "") {
                params.append(key, String(val));
              }
            });
          } else {
            params.append(id, value);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/warehouse/list/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "Warehosue.csv",
  };
};

export const fetchAllDropdownsWarehouse = createAsyncThunk(
  "warehouse/fetchAllDropdownsWarehouse",
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/api/warehouse/warehouse/column_filter/`,
        { params: { colum_filter: column } } // corrected spelling: "colum_filter"
      );

      const dropdownData = response.data?.data || response.data || [];

      console.log("Warehouse Dropdown API response:", dropdownData);

      return { column, data: dropdownData };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch dropdown");
    }
  }
);